export enum ModalActionsList {
  OPEN_MODAL = '[Modal] Open modal',
  BIND_EVENT = '[Modal] Bind events',
  CLOSE_MODAL = '[Modal] Close modal',

  RESET = '[Modal] Reset',
}
